import { Box } from '@mui/material'
import Confetti from 'react-confetti'

const styles = {
  confettiWrapper: {
    width: '100vw',
    height: '100vh',
    zIndex: 10,
    position: 'fixed',
    top: 0,
    left: 0,
    transform: 'translate3d(0,0,0)',
  },
}

type Props = {
  onClose: () => void
}

export const ConfettiWrapper = ({ onClose }: Props) => {
  return (
    <Box sx={styles.confettiWrapper} onClick={onClose}>
      <Confetti />
    </Box>
  )
}
